import React from 'react';
import { VisitAttributeSelectors } from './VisitAttributeSelectors';
import { AttributesDiv } from './AttributesDiv';
export const AttributesIcon = ({
  visitAttributes,
  appVisit,
  onSubmit
}) => appVisit ? /*#__PURE__*/React.createElement(VisitAttributeSelectors, {
  visitAttributes: visitAttributes,
  appVisit: appVisit,
  anchor: onClick => /*#__PURE__*/React.createElement(AttributesDiv, {
    onClick: onClick
  }, "A"),
  onSubmit: onSubmit
}) : /*#__PURE__*/React.createElement(React.Fragment, null);